module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-5-a877550e4fda72fa0cdf63c8e89b623d.png";